module.exports = __webpack_public_path__ + "img/slides.480bab32.png";